<template>
  <v-app>
    <v-content>
      <div class="hidden-theme-switcher" @click="$vuetify.theme.dark = !$vuetify.theme.dark"></div>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { STATE_LOGIN_TYPE } from '@/store'

import * as userTheme from '@/themes/user'
import * as adminTheme from '@/themes/admin'

export default {
  name: 'App',
  data: () => ({}),
  watch: {
    $route (to, from) {
      document.title = to.meta.title || 'BTM Login'
      this.setTheme()
    },
    darkTheme () {
      this.setTheme()
    },
    loginType () {
      this.setTheme()
    }
  },
  mounted () {
    this.$on('error', this.showError)
  },
  computed: {
    ...mapGetters({
      loginType: STATE_LOGIN_TYPE
    }),
    darkTheme () {
      if (!window.matchMedia) return false
      const queryList = window.matchMedia('(prefers-color-scheme: dark)')
      if (!queryList) return false
      return queryList.matches
    }
  },
  methods: {
    showError (err) {
      console.error(err)
    },
    setTheme () {
      console.log('setting theme')
      this.$vuetify.theme.dark = this.darkTheme
      switch (this.loginType) {
        case 0: // admin
          console.log('setting admin theme')
          this.$vuetify.theme.themes.dark = adminTheme.dark
          this.$vuetify.theme.themes.light = adminTheme.light
          document.documentElement.style.setProperty(
            '--color-bg-dark',
            '#1c1c1c'
          )
          document.documentElement.style.setProperty(
            '--color-bg-light',
            '#dcdccc'
          )
          break

        default:
          // user and default
          console.log('setting user theme')
          this.$vuetify.theme.themes.dark = userTheme.dark
          this.$vuetify.theme.themes.light = userTheme.light
          document.documentElement.style.setProperty(
            '--color-bg-dark',
            '#1c1c1c'
          )
          document.documentElement.style.setProperty(
            '--color-bg-light',
            '#de931e'
          )
          break
      }
    }
  }
}
</script>

<style>
:root {
  --color-bg-light: #1c1c1c;
  --color-bg-dark: #1c1c1c;
}

.theme--light.v-application {
  background: var(--color-bg-light) !important;
}

.theme--dark.v-application {
  background: var(--color-bg-dark) !important;
}

.hidden-theme-switcher {
  position: fixed;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
}
</style>
